/**
 * InfoR: a display-only notice block.
 *
 * Renders guidance text (from help_text, with an optional heading from labels)
 * as a styled callout. It holds no value and never registers with react-hook-
 * form, so it is skipped by validation, progress and the PDF value path. Use it
 * for conditional guidance, e.g. telling a de facto couple that WA and NT do
 * not offer relationship registration.
 */
import { Info } from 'lucide-react';
import type { FieldDef, RendererProps } from '../types';
import { resolveLabel, resolveHelpText } from '../utils';

interface Props extends RendererProps {
  field: FieldDef;
}

export function InfoR({ field, formId, audience }: Props) {
  const heading = resolveLabel(field, formId, audience);
  const body = resolveHelpText(field, audience);
  return (
    <div className="flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2.5 text-sm text-sky-900">
      <Info size={16} className="mt-0.5 shrink-0 text-sky-500" />
      <div>
        {heading && <p className="font-semibold">{heading}</p>}
        {body && <p className={heading ? 'mt-0.5' : ''}>{body}</p>}
      </div>
    </div>
  );
}
